import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, PropType, watch } from 'vue';

interface Marker {
  value: number;
  label?: string;
}

interface Limits {
  value: number;
  label?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SliderInput',
  props: {
  value: {
    type: Number,
    required: true,
  },
  min: {
    type: Object as PropType<Limits>,
    default: () => ({ value: 0, label: '' }),
  },
  max: {
    type: Object as PropType<Limits>,
    required: true,
  },
  showColorRanges: {
    type: Boolean,
    default: false,
  },
  showMarkers: {
    type: Boolean,
    default: false,
  },
  showThumb: {
    type: Boolean,
    default: true,
  },
  markers: {
    type: [Array, Number] as PropType<Marker[] | number[] | number>,
    default: () => [],
  },
  showTooltip: {
    type: String as PropType<'always' | 'hover'>,
  },
  tooltipPosition: {
    type: String as PropType<'top' | 'bottom'>,
    default: 'top',
  },
  tooltipFormatter: {
    type: [Function, String] as PropType<(value: number) => string | string>,
    default: (value: number) => value.toString(),
  },
  decimalPlaces: {
    type: Number,
    default: 0,
  },
  stepMultiplier: {
    type: Number,
    default: 0,
  },
},
  emits: { 'update:value': (_payload: number) => true },
  setup(__props, { emit }) {

const props = __props;





const sliderCurrentValue = ref();

const sliderCurrentValuePercentage = computed(() => {
  const range = props.max.value - props.min.value;
  const adjustedValue = sliderCurrentValue.value - props.min.value;

  if (sliderCurrentValue.value > props.max.value) {
    return 100;
  }

  return (adjustedValue * 100) / range;
});

const defaultMarkers = computed(() => {
  if (typeof props.markers === 'number') {
    const step = 100 / props.markers;
    return Array.from({ length: props.markers - 1 }, (_, index) => ({ value: step * (index + 1), label: '' }));
  }
  return props.markers.map((marker) => (typeof marker === 'number' ? { value: marker, label: '' } : marker));
});

const step = computed(() => {
  if (props.stepMultiplier > 0) {
    return props.stepMultiplier;
  } else if (props.decimalPlaces > 0) {
    return Math.pow(10, -props.decimalPlaces);
  }
  return 1;
});

function stepFactor(value: number) {
  let outValue = value;

  if (props.stepMultiplier > 0) {
    const multiplier = props.stepMultiplier;
    outValue = Math.round(outValue / multiplier) * multiplier;
  }

  if (props.decimalPlaces > 0) {
    const factor = Math.pow(10, props.decimalPlaces);
    outValue = Math.round(outValue * factor) / factor;
  }

  return outValue;
}

function handleSliderChange() {
  const value = stepFactor(sliderCurrentValue.value);

  sliderCurrentValue.value = value;
  emit('update:value', value);
}

function getTooltipContent() {
  const formattedValue = stepFactor(sliderCurrentValue.value);

  if (typeof props.tooltipFormatter === 'function') {
    return props.tooltipFormatter(formattedValue);
  } else if (typeof props.tooltipFormatter === 'string') {
    return (props.tooltipFormatter as string).replace('{value}', formattedValue.toString());
  }
  return formattedValue.toString();
}

function isActiveByPosition(stepValue: number) {
  return sliderCurrentValuePercentage.value > stepValue;
}

const isThumbHovered = ref(false);

function handleThumbMouseEnter() {
  if (props.showTooltip === 'hover') {
    isThumbHovered.value = true;
  }
}

function handleThumbMouseLeave() {
  if (props.showTooltip === 'hover') {
    isThumbHovered.value = false;
  }
}

watch(
  () => props.value,
  () => {
    sliderCurrentValue.value = props.value;
  },
  {
    immediate: true,
  }
);

return { __sfc: true,props, emit, sliderCurrentValue, sliderCurrentValuePercentage, defaultMarkers, step, stepFactor, handleSliderChange, getTooltipContent, isActiveByPosition, isThumbHovered, handleThumbMouseEnter, handleThumbMouseLeave }
}

})